import { TokenRefreshLink } from 'apollo-link-oauth-token-refresh';

import { getToken, setRefreshToken, setToken, getExpirationDate, setExpirationDate } from '@utils/localStorage';
import { calculateExpirationTime, isExpired } from '@utils/date';
import loginClient from '@services/OAuthServices/loginClient';

const isValidClientToken = (): boolean => {
  const checkToken = getToken();
  const expires = getExpirationDate();

  if (checkToken === null || checkToken === '' || expires === '' || expires === null) {
    return false;
  }

  return !isExpired(expires);
};

const OAuthLink = new TokenRefreshLink({
  isTokenValidOrUndefined: isValidClientToken,
  fetchAccessToken: () => {
    return loginClient();
  },
  handleResponse: () => (response: { error?: any; token_type?: any; access_token?: any; expires_in?: any }) => {
    if (response?.error) {
      setToken('');
      setRefreshToken('');

      return false;
    }
    const { token_type: type, access_token: token, expires_in: expires } = response;
    if (token) {
      const tokenRefreshed = `${type} ${token}`;
      const expirationDate = calculateExpirationTime(expires);

      setToken(tokenRefreshed);
      setExpirationDate(`${expirationDate}`);
      setRefreshToken('');

      return true;
    }

    setToken('');
    setRefreshToken('');
    return false;
  },
  handleError: () => {
    setToken('');
    setRefreshToken('');
  },
});

export default OAuthLink;
